import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {NucleoModel} from '../../../models/vmi-nucleoModel';
import {ClienteModel} from '../../../models/vmi-clienteModel';
import {VmiClientesService} from '../../../services/administracion/vmi-clientes.service';
import {ArticuloModel} from '../../../models/vmi-articuloModel';
import {VmiPenetracionService} from '../../../services/informes/vmi-penetracion.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SeguimientoModel } from '../../../models/vmi-seguimientoModel';
import { ItemsModel } from '../../../models/vmi-itemsModels';
import { ItemModel } from 'src/app/aplicaciones-modulos/distribuidores/models/itemModel';
import { CabSeguiModel } from '../../../models/vmi-cab-seguiModel';

@Component({
  selector: 'app-vmi-reporte-seguimiento',
  templateUrl: './vmi-reporte-seguimiento.component.html',
  styleUrls: ['./vmi-reporte-seguimiento.component.css']
})
export class VmiReporteSegumientoComponent implements OnInit {

  formulario: FormGroup;
  modulo: any = {};
  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};
  urlPdf: string = '';

  loading: boolean = false;
  cmbCliente: ClienteModel[] = [];
  cmbArticulo: ArticuloModel[] = [];

  lista: NucleoModel[];
  fechaInicio: string;

  seguimiento : SeguimientoModel[] = [];
  items : ItemsModel[] = [];

  listVmiStockfisico: number[] = []
  listVmiPorcpenetracionreal: number[] = [];
  listVmiFechaReg: string[] = [];

  listVmiAmortverde: number[] = [];
  listVmiAmortamarillo: number[] = [];
  listVmiAmortrojo: number[] = [];
  listaVacia: boolean = true;
  //Main
  columnDefs: any[];
  rowData: SeguimientoModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  //Details
  columnItemDefs: any[];
  rowItemsData: ItemsModel[] = [];
  frameworkItemsComponents: any;
  gridItemsApi: any;
  gridColumnItemsApi: any;
  rowItemsSelection: any;

  cabeceraSegui : CabSeguiModel = new CabSeguiModel();

  headerHeight = 150;

  imagenB64:string = "";

  isInventarioDetallado: boolean = false;

  constructor(
    private _penetracion: VmiPenetracionService,
    private _cliente: VmiClientesService,
    private _articulo: VmiArticulosService,
    private _utils: UtilsService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.penetracion;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      fechaInicio: ['', [Validators.required]],
      fechaFinal: ['', [Validators.required]],
      numCaso: ['', [Validators.required]]
    });
    this.getAllCliente();
    this.gridComponent();
    this.gridItemComponent();
    this.formulario.get('fechaFinal').setValue(this._utils.getCurrentDateGuion());
  }

  
  gridComponent() {
    
      this.columnDefs = [
        {
          headerName: 'TITULO',
          field: 'titulo',
          sortable: true,
          filter: true,
          width: 150
        },
        {
          headerName: 'FECHA',
          field: 'fecha',
          sortable: true,
          filter: true,
          width: 210
        },
        {
          headerName: 'UBICACION',
          field: 'ubicacion',
          sortable: true,
          resizable: true,
          filter: true,
          width: 150
        },
        {
          headerName: 'CONDUCTOR',
          field: 'conductor',
          wrapText: true,
          autoHeight: true,
          sortable: true,
          filter: true,
          resizable: true,
          width: 160
        },
        {
          headerName: 'VEHICULO',
          field: 'vehiculo',
          sortable: true,
          filter: true,
          width: 180
        }
      ];
    
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  gridItemComponent() {
    
    this.columnItemDefs = [
      {
        headerName: 'CODIGO',
        field: 'code',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'DESC. ITEM',
        field: 'description',
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: true,
        width: 150
      },      
      {
        headerName: 'DESPACHADAS',
        field: 'units',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ENTREGADAS',
        field: 'delivered_units',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ESTADO',
        field: 'status',
        sortable: true,
        filter: true,
        width: 160,
        valueGetter: function (data) {
          switch(data.data.status){
            case "pending":
              return 'Pendiente';
            case 'delivered':
              return 'Entregado' ;
            default:
              return data.data.status;  
          }
        }
      }
    ];
  
  this.frameworkItemsComponents = {
    buttonRenderer: LfsaBotonEditarGridComponent,
  };
  this.rowItemsSelection = 'multiple';
}


  getInvetarioDetallado() {
    console.log('inventario detallado');
    this.isInventarioDetallado = true;
    this.gridComponent();
    this.listaVacia = true;
    setTimeout(() => {
      this.listaVacia = false;
    }, 100);
  }

  notInvetarioDetallado() {
    console.log('not inventario detallado');
    this.isInventarioDetallado = false;
    this.gridComponent();
    setTimeout(() => {
      this.listaVacia = false;
    }, 100);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGridItemReady(params) {
    this.gridItemsApi = params.api;
    this.gridColumnItemsApi = params.columnApi;
  }


  getAllCliente() {
    this._cliente.getAll().subscribe((res: ClienteModel[]) => {
      this.cmbCliente = res;
    }, (err) => {
      this.cmbCliente = [];
    });
  }

  getArticuloByCliente() {
    this._articulo.getArticuloByCliente(this.formulario.get('cliente').value).subscribe((res: ArticuloModel[]) => {
      this.cmbArticulo = res;
    }, (err) => {
      this.cmbArticulo = [];
    });
  }

  buscar() {
    const fechaFinal = this.formulario.get('fechaFinal').value;
    const date = new Date(fechaFinal);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let mnth1 = ("0" + (date.getMonth())).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let fechaFin = [date.getFullYear(), mnth, day].join("-");
    this.fechaInicio = [date.getFullYear(), mnth1, day].join("-");
  }

  generarSeguimiento(){
      this.loading = true;
      this.listaVacia = true;
      let estadoRuta= "";
      let ciudad = "";
      this._penetracion.getPenetracionFiltradoSegumientoRaw(this.formulario.get('numCaso').value).subscribe(
        (res: any) => {
          this.loading = false;
          console.log(res);
          if(res.data !== undefined){
            this.seguimiento = [];
            this.items = [];
            this.urlPdf = res.data.tracking[0].address.order.url_pdf;
            this.listaVacia = false;
            if(res.data.tracking.length > 0){
              console.log(res.data.tracking[0].history[0].events);
              for( let item of res.data.tracking[0].history[0].events){
                estadoRuta = item.widget_event_name;
                ciudad = item.widget_location_area;
                this.seguimiento.push(new SeguimientoModel(
                  item.widget_event_name,
                  item.widget_location_area,
                  item.datetime,
                  res.data.tracking[0].history[0].vehicle_result.driver,
                  res.data.tracking[0].history[0].vehicle_result.vehicle));
              }
              this.rowData = this.seguimiento;
              for( let item of res.data.tracking[0].history[0].order.items){
                this.items.push(new ItemsModel(
                  item.code,
                  item.description,
                  item.units,
                  item.delivered_units,
                  item.item_status,
                  item.reason,
                  item.requested_units
                  ));
              }

            }
          }
          this.rowItemsData = this.items;
          this.cabeceraSegui.codCliente = res.data.tracking[0].address.code;
          this.cabeceraSegui.nomCliente = res.data.tracking[0].client;
          this.cabeceraSegui.direccion = res.data.tracking[0].address.address;
          this.cabeceraSegui.horaEstimada = res.data.tracking[0].address.eta;
          this.cabeceraSegui.estadoRuta = estadoRuta;
          this.cabeceraSegui.ciudad = ciudad;
          this.cabeceraSegui.esquema = res.data.tracking[0].schema_name;
          this.cabeceraSegui.direccionEsquema = res.data.tracking[0].schema_address;
          /*if(res.response[0].orders !== undefined)
          if(res.response[0].orders.length > 0){
            this.items =res.response[0].orders[0].items;
          }
          this.rowData = this.seguimiento;
          this.rowItemsData = this.items;
          console.log(this.seguimiento);
          console.log(this.items);*/
        }, (err) => {
          this.loading = false;
          console.log(err);
        }
      );
      /*this._penetracion.getPenetracionFiltradoSegumiento(
        this.formulario.get('fechaInicio').value,
        this.formulario.get('fechaFinal').value,
        this.formulario.get('numCaso').value
      ).subscribe((res: any) => {
        this.loading = false;
        console.log(res);
        if(res.response.length > 0){
          this.seguimiento = [];
          this.items = [];
          this.urlPdf = res.response[0].pdf_pod;
          this.listaVacia = false;
          if(res.response[0].visit_arrival !== null){
            this.seguimiento.push(
              new SeguimientoModel(
              "Pedido Entregado",
              res.response[0].address_city,
              res.response[0].visit_arrival,
              res.response[0].driver_name,
              res.response[0].vehicle_code));
          }
          if(res.response[0].route_started_at !== null){
            this.seguimiento.push(
              new SeguimientoModel(
              "Ruta Iniciada",
              res.response[0].employer_name,
              res.response[0].route_started_at,
              res.response[0].driver_name,
              res.response[0].vehicle_code));
          }
          if(res.response[0].route_approved_at !== null){
            this.seguimiento.push(
              new SeguimientoModel(
              "Ruta Aprobada",
              res.response[0].employer_name,
              res.response[0].route_approved_at,
              res.response[0].driver_name,
              res.response[0].vehicle_code));
          }
        }
        if(res.response[0].orders !== undefined)
        if(res.response[0].orders.length > 0){
          this.items =res.response[0].orders[0].items;
        }
        this.rowData = this.seguimiento;
        this.rowItemsData = this.items;
        console.log(this.seguimiento);
        console.log(this.items);
      }, (err) => {
        this.loading = false;
        console.log(err);
        this._utils.mensajeErroToast(err.error.mensaje);
      });*/
      //this._utils.descargarArchivoV2("Documento","Base64","Pdf");
  }

  abrirLink(){
    console.log(this.urlPdf)
    window.open(this.urlPdf);
  }

}
